import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { TranslateModule } from "@ngx-translate/core";
import { EditProfileComponent } from "./edit-profile.component";

@NgModule({
  declarations: [
    EditProfileComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    TranslateModule
  ],
  exports: [
    EditProfileComponent
  ]
})
export class EditProfileModule { }